<template>
  
  <div  class="player" :class="{'player-active':playing}">
    <div @click="toggleMp3" class="play-button" v-if="!playing"><font-awesome-icon  icon='play' /></div>
    <div @click="toggleMp3" class="play-button" v-if="playing"><font-awesome-icon  icon='pause' /></div>
    <div class="scrub-area">
      <div @click="seekTo" class="progress-bar-wrapper">
        <div :style="computeProgressBarStyle" class="progress-bar" :class="{'progress-bar-active':playing}"></div>
        <div class="duration" >{{computeCurrentTime}} / {{computeTotalTime}}</div>
      </div>
    </div>
    <audio ref="audio" class="audio-player">
      <source :src="media.url" type="audio/mpeg">
        :( Audio not supported..
    </audio>
 
  </div>

</template>

<script>
import { eventBus } from '../../services/EventBus.js';

export default {
  name: 'media-list',
  props:{
    media:{}
  },
  data(){
    return {
      playing:false,
      duration:0,
      currentTime:0,
    }
  },
  components: {
  },
  computed:{
    computeProgressBarStyle(){
      return {transform:"scaleX("+(this.currentTime/this.duration)+")"};
    },
    computeTotalTime(){
      // seconds to hours:minute:seconds
      var hours = Math.floor(this.duration / 3600);
      var minutes = (Math.floor(this.duration / 60)) % 60;
      var seconds = (this.duration - minutes * 60) % 60;

      var m=(100+minutes).toString().substr(1, 2);
      var s=(100+seconds).toString().substr(1, 2);

      return hours+":"+m+":"+s;
    },
    computeCurrentTime(){
      // seconds to hours:minute:seconds
      var hours = Math.floor(this.currentTime / 3600);
      var minutes = (Math.floor(this.currentTime / 60)) % 60;
      var seconds = (this.currentTime - minutes * 60) % 60;

      var m=(100+minutes).toString().substr(1, 2);
      var s=(100+seconds).toString().substr(1, 2);

      return hours+":"+m+":"+s;
    }
   
  },
  methods:{
   toggleMp3(){
     
     if(!this.playing){
       eventBus.$emit('STOP_OTHER_AUDIO');
       this.audio.play();

       
     }else{
      this.audio.pause();
      
     }
     this.playing=!this.playing;
   },
   stopAudio(){
     this.playing=false;
      this.audio.pause();
   },
   seekTo(e){
     var p=e.offsetX/e.target.clientWidth;
      this.audio.currentTime=this.audio.duration*p;
   },
   loadedmetadata(){
     //console.dir(this.audio);
     this.duration=this.audio.duration;
   },
   timedUpdate(){
      this.currentTime=this.audio.currentTime;
   },
   
   addEventListeners(){
     
    this.audio.addEventListener('loadedmetadata',this.loadedmetadata);
    this.audio.addEventListener('timeupdate',this.timedUpdate);
    //this.audio.addEventListener('canplay',this.canPlayMp3);
    
    eventBus.$on('STOP_OTHER_AUDIO',this.stopAudio);
   
   },
   removeEventListeners(){
    this.audio.removeEventListener('loadedmetadata',this.loadedmetadata);
    this.audio.removeEventListener('timeupdate',this.timedUpdate);
    //this.audio.removeEventListener('canplay',this.canPlayMp3);
    eventBus.$off('STOP_OTHER_AUDIO',this.stopAudio);
   }
    
  },
  beforeDestroy(){
    this.stopAudio();
    this.removeEventListeners()
  },
  
  mounted(){
    this.audio=this.$refs['audio'];
    this.addEventListeners();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.player{
  position:relative;
  margin-left:5px;
  flex:1;
  display:flex;
  align-items:center;
  border:1px solid grey;
  border-radius:4px;
  
}
.player-active{
  border:1px solid #0096E2!important;
}
.play-button{
  padding:2px 8px;
  color:#FFFFFF;
  background-color:#000000;
  border:1px solid white;
  border-radius:4px;

  font-size:.9em;
}

.scrub-area{
  position:relative;
  align-self: stretch;
  flex:1;
  
  
}
.progress-bar-wrapper{
  position:absolute;
  left:0;
  top:0;
  height:100%;
  width:100%;
  border:1px solid white;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  overflow:hidden;
}
.progress-bar{
  transform: translateZ(0);
  pointer-events: none;
  transform-origin: left top;
  height:100%;
  width:100%;
  background-color:rgba(0,0,0,.4)
}
.progress-bar-active{
  background-color:#0096E2;
}
.duration{
  position:absolute;
  left:0;
  top:0;
  height:100%;
  width:100%;
  font-size:.6em;
  display:flex;
  align-items: center;
}

</style>
